/* Wrapper */
.wrapper {
  margin: 20px 0;
}

.title {
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--secondary-text, #6b7280);
  margin: 0 0 2px 0;
}

.caption {
  font-size: 0.78rem;
  color: var(--secondary-text, #9ca3af);
  margin: 0 0 12px 0;
}

/* Horizontal scrolling strip */
.strip {
  display: flex;
  gap: 0;
  overflow-x: auto;
  padding-bottom: 4px;
  scroll-snap-type: x proximity;
  -webkit-overflow-scrolling: touch;
}

/* Hide scrollbar but keep functionality */
.strip::-webkit-scrollbar {
  height: 4px;
}

.strip::-webkit-scrollbar-thumb {
  background: var(--secondary-text, #d1d5db);
  border-radius: 2px;
}

.strip::-webkit-scrollbar-track {
  background: transparent;
}

/* Individual dyad card */
.card {
  flex: 0 0 auto;
  width: 150px;
  border: 1px solid var(--box-border-color, #e5e7eb);
  border-right: none;
  display: flex;
  flex-direction: column;
  scroll-snap-align: start;
  background: var(--main-background, #fff);
}

.card:last-child {
  border-right: 1px solid var(--box-border-color, #e5e7eb);
}

.cardClickable {
  cursor: pointer;
}

.cardClickable:hover {
  background: var(--light-grey, #f9fafb);
}

/* Country pair header */
.cardHeader {
  display: flex;
  flex-direction: column;
  padding: 10px 8px 8px;
  background: var(--header-bg, #1f2937);
  color: #fff;
  min-height: 52px;
  justify-content: center;
  gap: 3px;
}

.countryRow {
  display: flex;
  align-items: center;
  gap: 5px;
}

.flag {
  width: 18px;
  height: 13px;
  object-fit: cover;
  border-radius: 2px;
  flex-shrink: 0;
}

.flagFallback {
  width: 18px;
  text-align: center;
  font-size: 0.5rem;
  opacity: 0.5;
}

.countryName {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.2;
}

/* Status row */
.cardStatus {
  display: flex;
  justify-content: center;
  padding: 8px 6px;
}

.statusBadge {
  display: inline-block;
  font-size: 0.68rem;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 10px;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

/* Headline */
.cardHeadline {
  padding: 6px 8px 10px;
  font-size: 0.65rem;
  line-height: 1.4;
  color: var(--secondary-text, #6b7280);
  flex: 1;
}

/* Empty state */
.emptyMessage {
  font-size: 0.8rem;
  color: var(--secondary-text, #9ca3af);
  padding: 20px 0;
}

/* Highlight flash when navigating from card click */
.pulse {
  --pulse-color: #4c90f0;
  animation: highlightFlash 1.6s ease-out;
  border-radius: 6px;
}

@keyframes highlightFlash {
  0% {
    background-color: color-mix(in srgb, var(--pulse-color) 28%, transparent);
  }
  30% {
    background-color: color-mix(in srgb, var(--pulse-color) 14%, transparent);
  }
  100% {
    background-color: transparent;
  }
}
